import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postData } from '../API';
import { ToastContainer, toast } from "react-toastify";
import {jwtDecode} from 'jwt-decode';
function LoginForm() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const validateForm = () => {
        return username.trim() !== '' && password.trim() !== '';
    };

    const data={
        username,password
    }

    // const handleLogin = async (e) => {
    //     e.preventDefault()
    //     try {
    //         if (!validateForm()) {
    //             setError('Please fill in all fields.');
    //             return;
    //         }

    //         const response = await postData('Authentication/Login',data)
    //         const res = await response.json()
    //        if(res.statusCode===404){
    //         toast.error(res.message, {
    //                 position: "top-right",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //               });
    //        }

    //         const tokenData = jwtDecode(res.token)
    //         console.log("token",res.token)
    //         console.log(tokenData.UserId);
    //         localStorage.setItem("userId",tokenData.UserId)
    //         localStorage.setItem("userName",tokenData.DisplyName)
    //         localStorage.setItem("token",res.token)
    //         toast.success(res);
    //         if (tokenData.UserId) {
    //             // If login is successful, navigate to dashboard
    //             navigate('/dashboard');
    //         } else {
               
    //             console.log("ErrorMessage",res.message)
    //             // setError(res.message);
    //         }
    //     } catch (error) {
    //         console.error('Error logging in:', error);
           
    //     }
    // };
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            if (!validateForm()) {
                setError('Please fill in all fields.');
                return;
            }
    
            const response = await postData('Authentication/Login', data);
            console.log(response)
            // const res = await response.json();
    
            if (response.statusCode === 404) {
                toast.error(response.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }
    
            const tokenData = jwtDecode(response.token);
            console.log("tokenData",tokenData)
            console.log("response.token",response.token)
            // console.log("Token received:", response.token);
            // console.log("Decoded UserId:", tokenData.UserId);
            
            localStorage.setItem("userId", tokenData.UserId);
            localStorage.setItem("userName", tokenData.DisplyName);
            localStorage.setItem("token", response.token);
            localStorage.setItem("canWrite", tokenData.CanEdit);
           
            console.log(response.statusCode)
            toast.success("Login successful!");
             
            if (response.statusCode == 200) {
                navigate('/dashboard');
            } else {
                console.log("ErrorMessage:", response.message);
                setError(response.message);
            }
        } catch (error) {
            console.error('Error logging in:', error);
        }
    };
    
    return (
        <>
            <div className="container-fluid log_in">
                <div className="row align-items-center p-0 m-0">
                    <div className="col-xl-8 d-xs-none p-0">
                        <div className="bg_left">
                            <img src="img/image_topbanner.png" className="img-fluid" alt="Top Banner" />
                            <img src="img/image_bottombanner.png" className="img-fluid" alt="Bottom Banner" />
                        </div>
                    </div>
                    <div className="col-xl-4 col-12 p-0" >
                        <div className="Main_form" style={{backgroundColor: '#fff', height: '100vh'} }>
                            <div className="text-center">
                                <img src="img/logo-LSD.png" className="img-fluid" style={{ width: '40%' }} alt="Logo" />
                                <h4><b>Lucknow <br /> Swachhata Abhiyan</b></h4>
                                <p>private limited</p>
                            </div>
                            <form onSubmit={handleLogin}>
                                {/* Email input */}
                                <div className="form-outline mb-4">
                                    <input type="text" id="form2Example1" className="form-control" placeholder="User Name" value={username} autocomplete="off" onChange={(e) => setUsername(e.target.value)} />
                                </div>
                                {/* Password input */}
                                <div className="form-outline mb-4">
                                    <input type="password" id="form2Example2" className="form-control" placeholder="Password" value={password} autocomplete="off" onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                {/* Submit button */}
                                <button type="submit" className="btn btn-login btn-block mb-4 w-100" >Login</button>
                                {error && <div className=" text-danger" role="alert">{error}</div>}
                            </form>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
}

export default LoginForm;
